module.exports = __webpack_public_path__ + "img/toweled-img.9fad3443.png";